var exports = {
  "In": "TextualAttachmentPreview.module__textualPreview___UV9HNE",
  "KR": "TextualAttachmentPreview.module__previewSurface___UV9HNE",
  "cA": "TextualAttachmentPreview.module__previewActions___UV9HNE",
  "wL": "TextualAttachmentPreview.module__previewActionsVisible___UV9HNE",
  "VA": "TextualAttachmentPreview.module__previewActionButton___UV9HNE" + " " + __webpack_require__(180357)["AS"],
  "nJ": "TextualAttachmentPreview.module__copyIcon___UV9HNE",
  "fs": "TextualAttachmentPreview.module__inlinePreviewSurface___UV9HNE",
  "vd": "TextualAttachmentPreview.module__previewViewport___UV9HNE",
  "uL": "TextualAttachmentPreview.module__previewViewportCollapsed___UV9HNE",
  "q4": "TextualAttachmentPreview.module__previewViewportExpanded___UV9HNE",
  "Nv": "TextualAttachmentPreview.module__csvTableViewport___UV9HNE",
  "rV": "TextualAttachmentPreview.module__csvTableMarkup___UV9HNE",
  "uT": "TextualAttachmentPreview.module__previewCode___UV9HNE",
  "O9": "TextualAttachmentPreview.module__previewCodeWrap___UV9HNE",
  "VP": "TextualAttachmentPreview.module__previewError___UV9HNE",
  "Ml": "TextualAttachmentPreview.module__loadingState___UV9HNE",
  "qr": "TextualAttachmentPreview.module__footer___UV9HNE",
  "X1": "TextualAttachmentPreview.module__expandButton___UV9HNE" + " " + __webpack_require__(180357)["AS"],
  "eO": "TextualAttachmentPreview.module__expandIcon___UV9HNE",
  "t2": "TextualAttachmentPreview.module__expandIconExpanded___UV9HNE",
  "qt": "TextualAttachmentPreview.module__fileSection___UV9HNE",
  "gM": "TextualAttachmentPreview.module__fileMeta___UV9HNE",
  "Md": "TextualAttachmentPreview.module__fileName___UV9HNE",
  "Ov": "TextualAttachmentPreview.module__fileSize___UV9HNE",
  "zt": "TextualAttachmentPreview.module__footerActions___UV9HNE",
  "uH": "TextualAttachmentPreview.module__controlButton___UV9HNE" + " " + __webpack_require__(180357)["AS"],
  "RJ": "TextualAttachmentPreview.module__languagePositioner___UV9HNE",
  "tP": "TextualAttachmentPreview.module__languagePopup___UV9HNE",
  "Nl": "TextualAttachmentPreview.module__languageSearchWrap___UV9HNE",
  "nb": "TextualAttachmentPreview.module__languageSearchInput___UV9HNE",
  "qm": "TextualAttachmentPreview.module__languageEmpty___UV9HNE",
  "xl": "TextualAttachmentPreview.module__languageList___UV9HNE",
  "O6": "TextualAttachmentPreview.module__languageItem___UV9HNE",
  "d6": "TextualAttachmentPreview.module__languageItemHighlighted___UV9HNE",
  "J6": "TextualAttachmentPreview.module__languageItemSelected___UV9HNE",
  "_s": "TextualAttachmentPreview.module__languageOptionCanonical___UV9HNE",
  "xu": "TextualAttachmentPreview.module__languageItemIndicator___UV9HNE",
  "lh": "TextualAttachmentPreview.module__languageOptionContent___UV9HNE",
  "XO": "TextualAttachmentPreview.module__languageOptionCode___UV9HNE",
  "CR": "TextualAttachmentPreview.module__modalRoot___UV9HNE",
  "Ij": "TextualAttachmentPreview.module__modalLayout___UV9HNE",
  "S3": "TextualAttachmentPreview.module__modalBody___UV9HNE",
  "fn": "TextualAttachmentPreview.module__modalPreviewSurface___UV9HNE",
  "CM": "TextualAttachmentPreview.module__previewViewportFill___UV9HNE",
  "v6": "TextualAttachmentPreview.module__previewCodeFill___UV9HNE",
};

module.exports = exports;
